import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

@Component({
    selector: 'app-not-found',
    imports: [],
    templateUrl: './not-found.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './not-found.component.scss',
})
export class NotFoundComponent implements OnInit {
    readonly route = inject(ActivatedRoute)

    public message: string

    public ngOnInit(): void {
        this.message = this.route.snapshot.queryParams.customMessage
            ?? 'The page you are looking for can not be found'
    }
}
